import React from 'react';
import { upperFirst } from 'lodash';
import Tooltip from './Tooltip';
import StatusBadge from './StatusBadge';
import getChargeStatusLabel from '@dashboard/services/status/getChargeStatusLabel';

export function PaymentStatusBadges({ payment }) {
  const { orderStatus, status, livemode, paymentError, isAbandoned } = payment;
  const isCanceled = orderStatus === 'canceled';
  const isArchived = orderStatus === 'archived';
  const isRefunded = status === 'refunded' || status === 'partial_refund';

  // Show "Abandoned" for draft orders that were abandoned
  if (status === 'draft' && isAbandoned) {
    return <StatusBadge status="abandoned" label="Abandoned" livemode={livemode} />;
  }

  // Show "Recovered" for positive status orders that were abandoned
  if (isAbandoned && (status === 'paid' || status === 'partially_paid' || status === 'active')) {
    return <StatusBadge status="recovered" label="Recovered" livemode={livemode} />;
  }

  if ((isCanceled || isArchived) && !isRefunded) {
    return <StatusBadge status={orderStatus} label={upperFirst(orderStatus)} livemode={livemode} />;
  }

  if (isCanceled && isRefunded) {
    return (
      <>
        <StatusBadge status={orderStatus} label={upperFirst(orderStatus)} livemode={livemode} />
        <StatusBadge status={status} label={getChargeStatusLabel(status)} livemode={livemode} />
      </>
    );
  }

  return (
    <Tooltip label={paymentError} side="right">
      <StatusBadge status={status} label={getChargeStatusLabel(status)} livemode={livemode} />
    </Tooltip>
  );
}
